import React from "react";
import { FaSearch } from "react-icons/fa";

interface SearchBarProps {
  placeholder?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  value?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ placeholder = "Search...", onChange , className,value}) => {
  return (
    <div className={`${className} relative w-auto max-w-full`}>
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        className="w-full pl-4 pr-10 py-2 rounded-full bg-[var(--color-surface)] border border-[var(--color-border)] text-sm text-[var(--color-text)] placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
        onChange={onChange}
      />
      <FaSearch className="absolute right-3 top-2.5 text-gray-400 text-sm" />
    </div>
  );
};

export default SearchBar;